import React from "react";
import {observer} from "mobx-react";
import {TimeSpan} from "@sparkware/app-utils";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {SessionCooldownPopupBox} from "./boxes/session-cooldown.popup.box";
import {SessionCooldownPopupTextBox} from "./boxes/session-cooldown-popup-text.box";
import {SessionCooldownPopupTimerBox} from "./boxes/session-cooldown-popup-timer.box";
import {SessionCooldownPopupTimerRemainingBox} from "./boxes/session-cooldown-popup-timer-remaining.box";
import {CyClass} from "../../../common/cy-classes";

export interface ISessionCooldownPopupComponentProps {
  countdown: TimeSpan;
}

export const SessionCooldownPopupComponent = observer(
  class SessionCooldownPopupComponent extends OrbitComponent<ISessionCooldownPopupComponentProps> {

    private _prependZero(value: number): string {
      if (value < 10) {
        return `0${value}`;
      } else {
        return `${value}`;
      }
    }

    render() {
      return (
        <SessionCooldownPopupBox className={CyClass("cy-session-cooldown-popup")}>
          <SessionCooldownPopupTimerBox>
            {this._prependZero(this.props.countdown.minutes)}:{this._prependZero(this.props.countdown.seconds)}
          </SessionCooldownPopupTimerBox>
          <SessionCooldownPopupTimerRemainingBox>
            {this.services.translation.translate("SESSION_COOLDOWN_POPUP_REMAINING")}
          </SessionCooldownPopupTimerRemainingBox>
          <SessionCooldownPopupTextBox>
            {this.services.translation.translate("SESSION_COOLDOWN_POPUP_INFO_TEXT")}
          </SessionCooldownPopupTextBox>
        </SessionCooldownPopupBox>
      );
    }
  }
);
